import { createAction, props } from '@ngrx/store';

export enum ToastActionTypes {
  ShowToastSuccessMessage = '[Toast] ShowToastSuccessMessage',
  ShowToastWarningMessage = '[Toast] ShowToastWarningMessage',
  ShowToastErrorMessage = '[Toast] ShowToastErrorMessage',
}

export const showToastSuccessMessageAction = createAction(ToastActionTypes.ShowToastSuccessMessage, props<{ message: string }>());
export const showToastWarningMessageAction = createAction(ToastActionTypes.ShowToastWarningMessage, props<{ message: string }>());
export const showToastErrorMessageAction = createAction(ToastActionTypes.ShowToastErrorMessage, props<{ message: string }>());
